export default "__VITE_ASSET__DgxaZdAc__"